export default __webpack_public_path__ + "static/media/logo.70a6dc74.png";